<header>
  <section class="external-links cell" aria-label="External Links">
    <div class="grid-x grid-padding-x align-middle">
      <div class="cell small-12 medium-6 show-for-medium icon-links">
        <a href="https://www.facebook.com/ohiodnr/" target="_blank" class="small-margin" aria-label="Facebook Link" title="ODNR Facebook">
          <span class="show-for-sr">Facebook Link</span>
          <svg-icon icon="icon-social-facebook" class="white small"></svg-icon>
        </a>
        <a href="https://twitter.com/ohiodnr" target="_blank" class="small-margin" aria-label="Twitter Link" title="ODNR Twitter">
          <span class="show-for-sr">Twitter Link</span>
          <svg-icon icon="icon-social-twitter" class="white small"></svg-icon>
        </a>
        <a href="https://www.youtube.com/user/TheOhioDNR" target="_blank" class="small-margin" aria-label="YouTube Link" title="ODNR Youtube Channel">
          <span class="show-for-sr">YouTube Link</span>
          <svg-icon aria-hidden="true" icon="icon-youtube" class="white small"></svg-icon>
        </a>
        <a href="https://www.instagram.com/ohiodnr/" target="_blank" class="small-margin" aria-label="Instagram Link" title="ODNR Instagram">
          <span class="show-for-sr">Instagram Link</span>
          <svg-icon aria-hidden="true" icon="icon-instagram" class="white small"></svg-icon>
        </a>
      </div>
      <div class="cell small-12 medium-6">
        <div class="external-links-right">
          <a href="http://ohio.gov" target="_blank">Ohio.gov</a><a href="https://ohio.gov/wps/portal/gov/site/government/state-agencies/state-agencies/" target="_blank">Agencies</a><a href="https://ohio.gov/wps/portal/gov/site/residents/topic-hubs/top-services/top-services/"
        target="_blank">Services</a>
      </div>
    </div>
  </div>
</section>
<div class="cell shrink header">
  <div class="odnr-logo-container">
    <a [routerLink]="['/home']" title="Home"><span class="show-for-sr">Home</span><img alt="ODNR Oil & Gas Resources Logo" class="odnr-logo" src="../../../assets/images/logo-home.png" /></a>
  </div>
  <div class="login-nav-container">
    <div class="login-bar text-right">
      @if (isLoggedIn) {
        <div class="login-user-name">
          <svg-icon class="medium-gray tiny" icon="icon-torso" aria-hidden="true">
          </svg-icon>
          {{user?.displayName}}
        </div>
      }
      @if (isLoggedIn) {
        <span class="login-spacer">|</span>
      }
      @if (acceptedCookies || isLoggedIn) {
        @if (!isLoggedIn) {
          <button class="linkButton" (click)="login()">Login</button>
        }
        @if (isLoggedIn) {
          <button class="linkButton" (click)="logout()">Logout</button>
        }
      } @else {
        <button class="linkButton" (click)="promptCookiesBeforeLogin()">Login</button>
        <a href="/api/login" style="display: none" #login></a>
      }
    </div>
    <nav-menu></nav-menu>
  </div>
</div>
</header>

